import React from 'react';

import { DialogContent } from '@crehana/ui';

import useSocialNetworkShare from 'Shared/Hooks/useSocialNetworkShare';
import ShareButton from 'Shared/ShareButton';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

interface ShareDialogContentProps {
  liveUrl: string;
}

const ShareDialogContent: React.FC<ShareDialogContentProps> = ({ liveUrl }) => {
  const { t } = useCrehanaLiveTranslations();

  const [onShareFaceebook] = useSocialNetworkShare({
    to: 'facebook',
    url: liveUrl,
  });
  const [onShareLinkedin] = useSocialNetworkShare({
    to: 'linkedin',
    url: liveUrl,
  });
  const [onShareTwitter] = useSocialNetworkShare({
    to: 'twitter',
    url: liveUrl,
    hashtags: ['CrehanaLive'],
  });

  return (
    <DialogContent
      mainTitle={t('SHARE_lIVE')}
      body={t('SHARE_LIVE_DESCRIPTION')}
    >
      <div className="flex flex-col items-center">
        <ShareButton
          className="mb-24"
          socialNetwork="Facebook"
          onShare={() => onShareFaceebook()}
        />
        <ShareButton
          className="mb-24"
          socialNetwork="Twitter"
          onShare={() => onShareTwitter()}
        />
        <ShareButton
          socialNetwork="Linkedin"
          onShare={() => onShareLinkedin()}
        />
      </div>
    </DialogContent>
  );
};

export default ShareDialogContent;
